/**
 * ログインせずに作った診断の「合言葉」（doc/AUTH.md §2）。
 *
 * 作成の応答で 1 回だけ返るので、このブラウザに覚えておく。あとでログインしたとき、
 * これを添えると自分の診断として引き取れて、絵を付けられる。
 * サーバはハッシュだけを持っていて、生の値はここにしか無い（消えたら引き取れないが、診断自体は動く）。
 */
const KEY = 'gendan.creatorTokens';
const MAX = 30;

type Bag = Record<string, string>;

function read(): Bag {
  try {
    const raw = window.localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Bag) : {};
  } catch {
    return {};
  }
}

export function rememberCreatorToken(themeId: string, token: string | null): void {
  if (!token) return;
  try {
    const bag = read();
    bag[themeId] = token;
    // 古いものから落として、際限なく溜めない
    const entries = Object.entries(bag).slice(-MAX);
    window.localStorage.setItem(KEY, JSON.stringify(Object.fromEntries(entries)));
  } catch { /* 書けなくても診断は動く */ }
}

export const creatorTokenFor = (themeId: string): string | undefined => read()[themeId];

export function forgetCreatorToken(themeId: string): void {
  try {
    const bag = read();
    delete bag[themeId];
    window.localStorage.setItem(KEY, JSON.stringify(bag));
  } catch { /* 無視 */ }
}
